import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTabBar = styled.ul`
    margin: 0;
    padding: 0;
    list-style-type: none;
    display: flex;
    height: ${({ theme }) => (theme.spacing * 6)}px;
`;

const TabListItem = styled.li`
  flex-grow: 1;
  flex-basis: 0;

  button {
    border: 0;
    background: ${({ active, theme }) => theme.palette.secondary[active ? 'contrastText' : 'main']};
    border-top: ${({ active, theme }) => theme.palette[active ? 'primary' : 'secondary'].main} solid 4px;
    width: 100%;
    height: 100%;
    outline: none;
    cursor: pointer;

    h4 {
      margin: 0;
      color: ${({ active, theme }) => (active ? 'inherit' : theme.palette.secondary.contrastText)};
    }
  }
`;

const TabBar = ({ className, tabs, onTabClick }) => {
  const classes = ['TabBar', className];
  const [selectedTab, setSelectedTab] = useState(0);

  const handleOnClick = (tab, index) => {
    setSelectedTab(index);
    onTabClick(tab);
  };

  return (
    <StyledTabBar className={classes.filter((c) => !!c).join(' ')}>
      {
        tabs.map((tab, index) => (
          <TabListItem key={tab.label} active={selectedTab === index}>
            <button type="button" onClick={() => handleOnClick(tab, index)}>
              <h4>{tab.label}</h4>
            </button>
          </TabListItem>
        ))
      }
    </StyledTabBar>
  );
};

TabBar.displayName = 'TabBar';

TabBar.propTypes = {
  className: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onTabClick: PropTypes.func.isRequired,
};

TabBar.defaultProps = {
  className: null,
};

export default TabBar;
